var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCad = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9994 12.268C23.9994 7.51049 21.2307 3.39974 17.2168 1.45874V23.0773C21.2307 21.1363 23.9994 17.0256 23.9994 12.268Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.268C0 17.0256 2.76867 21.1363 6.78262 23.0773V1.45874C2.76867 3.39974 0 7.51049 0 12.268Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.087 13.8324L16.174 12.7889L15.1305 12.2672V11.2237L13.0435 12.2672L14.087 10.1802H13.0435L12.0001 8.61499L10.9566 10.1802H9.91309L10.9566 12.2672L8.86961 11.2237V12.2672L7.82617 12.7889L9.91309 13.8324L9.39138 14.8759H11.4783V16.4411H12.5218V14.8759H14.6088L14.087 13.8324Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CAD.f7da25c101fe456bd3ee34131abd11ec.svg";